export default __webpack_public_path__ + "static/media/iconCordova.40ae7e4c.png";